// src/api/panelImages.ts

import api from '@/lib/axios';
import type { PanelImage, ImageListResponse } from '@/types/panelImage';

/**
 * 上传面板图片（自动版本）
 * POST /v1/developer/panels/{panel_id}/images
 * @param panelId - 面板 ID
 * @param file - 图片文件
 */
export const uploadImage = (
  panelId: string,
  file: File
): Promise<PanelImage> => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`/developer/panels/${panelId}/images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/**
 * 获取面板图片列表
 * GET /v1/developer/panels/{panel_id}/images
 * @param panelId - 面板 ID
 * @returns Promise<ImageListResponse> - 包含 { images: [...] } 结构
 */
export const getImages = (panelId: string): Promise<ImageListResponse> => {
  return api.get(`/developer/panels/${panelId}/images`);
};

/**
 * 删除面板图片
 * DELETE /v1/developer/panels/{panel_id}/images/{filename}
 * @param panelId - 面板 ID
 * @param filename - 文件名
 */
export const deleteImage = (panelId: string, filename: string): Promise<void> => {
  return api.delete(`/developer/panels/${panelId}/images/${filename}`);
};

/**
 * 下载面板图片（直接使用 CDN URL）
 * 注意：此函数仅用于类型安全，实际使用中直接使用 file_url 即可
 * @param fileUrl - 后端返回的 CDN URL（已包含预签名）
 */
export const downloadImage = (fileUrl: string): void => {
  // 直接在新窗口打开 CDN URL
  window.open(fileUrl, '_blank');
};